import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import {
  inchesToFeet,
  isPresent,
  objectKeysToSnakeCase,
} from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

// Note: $ is loaded globally

class SpaceGroupModal extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  closeModal() {
    this.setState({ showModal: false })
    this.validator.hideMessages()
  }

  openModal() {
    const spaceGroup = { ...this.props.spaceGroup }

    if (this.props.edit) {
      const loaDependentParams = [
        "total",
        "warningThreshold",
        "dangerThreshold",
        "autoConfirmThreshold",
      ]
      if (spaceGroup.type.includes("SpaceGroup::Linear")) {
        loaDependentParams.forEach((param) => {
          spaceGroup[param] = spaceGroup[param] / 12
        })
      } else if (spaceGroup.type === "SpaceGroup::SquareFootage") {
        loaDependentParams.forEach((param) => {
          spaceGroup[param] = spaceGroup[param] / 144
        })
      }
    }

    this.setState({
      showModal: true,
      spaceGroup: this.props.edit
        ? {
            ...spaceGroup,
            dockType: isPresent(spaceGroup.dockType)
              ? spaceGroup.dockType
              : "All",
            minLength: inchesToFeet(spaceGroup.minLength),
            maxLength: inchesToFeet(spaceGroup.maxLength),
            minBeam: spaceGroup.minBeam && inchesToFeet(spaceGroup.minBeam),
            maxBeam: spaceGroup.maxBeam && inchesToFeet(spaceGroup.maxBeam),
            minDraft: spaceGroup.minDraft && inchesToFeet(spaceGroup.minDraft),
            maxDraft: spaceGroup.maxDraft && inchesToFeet(spaceGroup.maxDraft),
            bufferSize:
              spaceGroup.bufferSize && inchesToFeet(spaceGroup.bufferSize),
          }
        : {
            ...spaceGroup,
            dockType: "",
            type: "",
            minBeam: this.props.defaultLengths.minBeamFeet,
            maxBeam: this.props.defaultLengths.maxBeamFeet,
            minDraft: this.props.defaultLengths.minDraftFeet,
            maxDraft: this.props.defaultLengths.maxDraftFeet,
          },
    })
  }

  modalButton() {
    return (
      <button
        type="button"
        className="btn btn-primary"
        onClick={this.openModal}
      >
        {" "}
        New Space Group
      </button>
    )
  }

  editButton() {
    return (
      <button
        type="button"
        className="btn btn-secondary"
        onClick={this.openModal}
      >
        Edit
      </button>
    )
  }

  labelWithSup(text, num, id) {
    return (
      <label htmlFor={id}>
        {text}
        <sup>{num}</sup>
      </label>
    )
  }

  spanWithSup(text, num) {
    return (
      <span>
        {text}
        <sup>{num}</sup>
      </span>
    )
  }

  orientationLabel() {
    return (
      <div className="ml-2 flex w-64">
        <div id="orientation" style={{ fontWeight: "600" }}>
          Orientation of this dock runs from:
          <sup>6</sup>
        </div>
        <p className="ml-1 text-red-700">*</p>
      </div>
    )
  }

  handleSubmit() {
    this.validator.showMessages()
    const params = _.mapKeys(this.state.spaceGroup, objectKeysToSnakeCase)
    if (this.validator.allValid()) {
      this.setState({
        saving: true,
      })
      this.submit(params)
    }
  }

  submit(params) {
    if (params.dock_type === "All") {
      params.dock_type = ""
    }
    if (this.props.edit) {
      $.patch(
        `${this.props.endPoint}/${this.state.spaceGroup.id}`,
        params,
        (data) => {
          window.location.reload()
        }
      ).fail((data) => {
        this.setState({
          saving: false,
          validationErrorMessage:
            "Something went wrong updating this space group",
        })
      })
    } else {
      $.post(this.props.endPoint, params, (data) => {
        window.location.reload()
      }).fail((data) => {
        this.setState({
          saving: false,
          validationErrorMessage:
            "Something went wrong creating this space group",
        })
      })
    }
  }

  renderAutomaticBookingSettingsBlock() {
    return (
      <div className="mb-10">
        <div className="bg-light-gray mt-4 rounded border p-4">
          <h4 className="mb-4 mt-2">Automatic Booking Settings</h4>
          <div className="row form-row">
            <div className="col-md-6">
              {this.props.autoConfirmVisible && (
                <div>
                  {this.labelWithSup(
                    "Automatic Confirmations",
                    "4",
                    "autoConfirmations"
                  )}
                  {this.props.autoConfirmEnabled ? (
                    <FormGroup
                      id="autoConfirmations"
                      inputType="input"
                      name="spaceGroup.autoConfirmThreshold"
                      pattern="\d*"
                      onChange={this.handleInputChange}
                      value={this.state.spaceGroup.autoConfirmThreshold}
                      validation={this.validator.message(
                        "Automatic Confirmation",
                        this.state.spaceGroup.autoConfirmThreshold,
                        "required"
                      )}
                    />
                  ) : (
                    <p className="mb-3">
                      Auto Confirm lets Dockwa confirm the bulk of
                      boater-requested reservations for you, according to the
                      available space in the space groups that have this setting
                      on.{" "}
                      <a href="https://ahoy.dockwa.com/learn/dock-management/auto-confirm">
                        Learn more about Auto Confirm
                      </a>
                      .
                    </p>
                  )}
                </div>
              )}
            </div>
            <div className="col-md-6">
              {this.props.autoThrottleVisible && (
                <div>
                  {this.labelWithSup(
                    "Calendar Block Threshold",
                    "5",
                    "calendarblock"
                  )}
                  {this.props.autoThrottleEnabled ? (
                    <FormGroup
                      id="calendarblock"
                      inputType="input"
                      name="spaceGroup.dangerThreshold"
                      pattern="\d*"
                      onChange={this.handleInputChange}
                      value={this.state.spaceGroup.dangerThreshold}
                      validation={this.validator.message(
                        "Calendar Block Threshold",
                        this.state.spaceGroup.dangerThreshold,
                        "required"
                      )}
                    />
                  ) : (
                    <p>
                      With Auto-Block on, Dockwa will automatically block dates
                      on your booking calendar when space groups fill up, giving
                      boaters information to make a reservation when there is
                      availability. Contact your Dockwa rep to turn on
                      Auto-Block.
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderFormInstructions() {
    return (
      <div className="row form-row">
        <div className="col-sm-6">
          <ol>
            <li className="mb-2">
              For boat count, enter total number of boats the space group can
              accommodate. For linear footage, enter the total sum of feet
              available.
            </li>
            <li className="mb-2">
              (optional) Maximum number of nights space can be reserved.
            </li>
            <li>
              (optional) Number of days from &quot;today&quot; a boater can
              request to reserve this space.
            </li>
          </ol>
        </div>
        <div className="col-sm-6">
          <ol start="4">
            <li className="mb-2">
              Number of units that will be automatically confirmed before
              &quot;pending&quot; reservations will need to be manually
              confirmed or declined.
            </li>
            <li className="mb-2">
              Number of units left when the corresponding date(s) on the booking
              calendar will automatically be blocked for further reservation
              requests unless the date is manually unblocked.
            </li>
            {this.props.hasLinearDockageEnabled && (
              <li>
                Use universal directional terms when describing orientation.
              </li>
            )}
          </ol>
        </div>
      </div>
    )
  }

  renderModal() {
    this.validator.purgeFields()
    return (
      this.state.showModal && (
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="large"
        >
          <Modal.Header title={this.props.modalTitle} />
          <Modal.Body>
            <div className="row form-row">
              <div className="col-sm-6">
                <FormGroup
                  inputType="input"
                  value={this.state.spaceGroup.name}
                  name="spaceGroup.name"
                  label="Name of Space Group"
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                  validation={this.validator.message(
                    "space_group_name",
                    this.state.spaceGroup.name,
                    "required"
                  )}
                />
              </div>
              <div className="col-sm-6">
                <FormGroup
                  inputType="select"
                  value={this.state.spaceGroup.dockType}
                  name="spaceGroup.dockType"
                  label="Space Type"
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                  validation={this.validator.message(
                    "space_type",
                    this.state.spaceGroup.dockType,
                    "required"
                  )}
                >
                  <option value="" disabled={true}>
                    Select Type
                  </option>
                  <option value="All">All</option>
                  <option value="Mooring">Mooring</option>
                  <option value="Dock">Dock</option>
                  <option value="Storage">Storage</option>
                </FormGroup>
              </div>
            </div>
            <div className="row form-row">
              <div className="col-sm-6">
                <FormGroup
                  inputType="select"
                  value={this.state.spaceGroup.type}
                  name="spaceGroup.type"
                  label="Type of Inventory"
                  onChange={this.handleInputChange}
                  disabled={
                    this.props.hasLinearDockageEnabled && this.props.edit
                  }
                  validation={this.validator.message(
                    "type_of_inventory",
                    this.state.spaceGroup.type,
                    "required"
                  )}
                >
                  <option value="" disabled={true}>
                    Select Type
                  </option>
                  <option value="SpaceGroup::Count">Boat Count</option>
                  <option
                    value={
                      this.props.hasLinearDockageEnabled
                        ? "SpaceGroup::LinearV2"
                        : "SpaceGroup::Linear"
                    }
                  >
                    Linear Footage
                  </option>
                  {this.props.hasLinearDockageEnabled &&
                    this.props.hasDeprecatedLoaSpaceGroup && (
                      <option value="SpaceGroup::Linear">
                        Linear Footage (deprecated)
                      </option>
                    )}
                  <option value="SpaceGroup::SquareFootage">
                    Square Footage
                  </option>
                </FormGroup>
              </div>
              <div className="col-sm-6">
                <FormGroup
                  inputType="input"
                  value={this.state.spaceGroup.total}
                  name="spaceGroup.total"
                  label={this.spanWithSup("Total Inventory", "1")}
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                  validation={this.validator.message(
                    "total_inventory",
                    this.state.spaceGroup.total,
                    "required"
                  )}
                />
              </div>
            </div>
            <h4>Details</h4>
            {this.state.spaceGroup.type === "SpaceGroup::LinearV2" && (
              <div className="row form-row">
                <div className="col-sm-6">
                  <FormGroup
                    inputType="feet"
                    value={this.state.spaceGroup.bufferSize}
                    name="spaceGroup.bufferSize"
                    label="Buffer Zone (optional)"
                    onChange={this.handleInputChange}
                    disabled={this.props.disabled}
                    validation={this.validator.message(
                      "buffer_size",
                      this.state.spaceGroup.bufferSize,
                      "numeric|min:0,num|max:2000,num"
                    )}
                  />
                </div>
                <div className="col-sm-6">
                  <div className="row form-row">
                    {this.orientationLabel()}
                    <div className="-mt-1 flex justify-between">
                      <div className="col-sm-6">
                        <FormGroup
                          inputType="input"
                          value={this.state.spaceGroup.orientationStart}
                          name="spaceGroup.orientationStart"
                          ariaLabelledBy="orientation"
                          onChange={this.handleInputChange}
                          disabled={this.props.disabled}
                          validation={this.validator.message(
                            "orientation_start",
                            this.state.spaceGroup.orientationStart,
                            "required"
                          )}
                        />
                      </div>
                      <p className="mx-1 mt-2">to</p>
                      <div className="col-sm-6">
                        <FormGroup
                          inputType="input"
                          value={this.state.spaceGroup.orientationEnd}
                          name="spaceGroup.orientationEnd"
                          ariaLabelledBy="orientation"
                          onChange={this.handleInputChange}
                          disabled={this.props.disabled}
                          validation={this.validator.message(
                            "orientation_end",
                            this.state.spaceGroup.orientationEnd,
                            "required"
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row form-row">
              <div className="col-sm-6">
                <FormGroup
                  inputType="feet"
                  value={this.state.spaceGroup.minLength}
                  name="spaceGroup.minLength"
                  label="Min LOA"
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                  validation={this.validator.message(
                    "min_length",
                    this.state.spaceGroup.minLength,
                    "required|numeric|min:0,num|max:2000,num"
                  )}
                />
              </div>
              <div className="col-sm-6">
                <FormGroup
                  inputType="feet"
                  value={this.state.spaceGroup.maxLength}
                  name="spaceGroup.maxLength"
                  label="Max LOA"
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                  validation={this.validator.message(
                    "max_length",
                    this.state.spaceGroup.maxLength,
                    "required|numeric|min:0,num|max:2000,num"
                  )}
                />
              </div>
            </div>
            <div className="row form-row">
              <div className="col-sm-6">
                <FormGroup
                  inputType="feet"
                  value={this.state.spaceGroup.minBeam}
                  name="spaceGroup.minBeam"
                  label="Min Beam"
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                  validation={this.validator.message(
                    "min_beam",
                    this.state.spaceGroup.minBeam,
                    "required|numeric|min:0,num|max:1000,num"
                  )}
                />
              </div>
              <div className="col-sm-6">
                <FormGroup
                  inputType="feet"
                  value={this.state.spaceGroup.maxBeam}
                  name="spaceGroup.maxBeam"
                  label="Max Beam"
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                  validation={this.validator.message(
                    "max_beam",
                    this.state.spaceGroup.maxBeam,
                    "required|numeric|min:0,num|max:1000,num"
                  )}
                />
              </div>
            </div>
            <div className="row form-row">
              <div className="col-sm-6">
                <FormGroup
                  inputType="feet"
                  value={this.state.spaceGroup.minDraft}
                  name="spaceGroup.minDraft"
                  label="Min Draft"
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                  validation={this.validator.message(
                    "min_draft",
                    this.state.spaceGroup.minDraft,
                    "required|numeric|min:0,num|max:1000,num"
                  )}
                />
              </div>
              <div className="col-sm-6">
                <FormGroup
                  inputType="feet"
                  value={this.state.spaceGroup.maxDraft}
                  name="spaceGroup.maxDraft"
                  label="Max Draft"
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                  validation={this.validator.message(
                    "max_draft",
                    this.state.spaceGroup.maxDraft,
                    "required|numeric|min:0,num|max:1000,num"
                  )}
                />
              </div>
            </div>
            <div className="row form-row">
              <div className="col-sm-6">
                <FormGroup
                  inputType="text-icon"
                  iconText="nights"
                  value={this.state.spaceGroup.maxNights}
                  name="spaceGroup.maxNights"
                  label={this.spanWithSup(
                    "Max Reservation Length (optional)",
                    "2"
                  )}
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                />
              </div>
              <div className="col-sm-6">
                <FormGroup
                  inputType="text-icon"
                  iconText="days"
                  value={this.state.spaceGroup.daysInAdvance}
                  name="spaceGroup.daysInAdvance"
                  label={this.spanWithSup(
                    "Days-in-Advance Space can be Reserved (optional)",
                    "3"
                  )}
                  onChange={this.handleInputChange}
                  disabled={this.props.disabled}
                />
              </div>
            </div>
            {this.validator.messageWhenPresent(
              this.state.validationErrorMessage
            )}
            {this.props.autoConfirmVisible || this.props.autoThrottleVisible
              ? this.renderAutomaticBookingSettingsBlock()
              : null}
            {this.renderFormInstructions()}
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText={this.props.saveBtnText || "Save"}
            onClose={this.closeModal}
            onSubmit={this.handleSubmit}
            confirmBtnLoading={this.state.saving}
          />
        </Modal>
      )
    )
  }

  render() {
    return (
      <div>
        {this.props.edit ? this.editButton() : this.modalButton()}
        {this.renderModal()}
      </div>
    )
  }
}

SpaceGroupModal.propTypes = {
  autoConfirmEnabled: PropTypes.bool,
  autoConfirmVisible: PropTypes.bool,
  autoThrottleEnabled: PropTypes.bool,
  autoThrottleVisible: PropTypes.bool,
  defaultLengths: PropTypes.shape({
    minBeamFeet: PropTypes.number,
    maxBeamFeet: PropTypes.number,
    minDraftFeet: PropTypes.number,
    maxDraftFeet: PropTypes.number,
  }).isRequired,
  disabled: PropTypes.bool,
  edit: PropTypes.bool,
  endPoint: PropTypes.string.isRequired,
  hasDeprecatedLoaSpaceGroup: PropTypes.bool,
  hasLinearDockageEnabled: PropTypes.bool,
  modalTitle: PropTypes.string.isRequired,
  saveBtnText: PropTypes.string,
  spaceGroup: PropTypes.object.isRequired,
}

export default SpaceGroupModal
